import {
  APP_LOAD,
  REDIRECT,
  LOGIN,
  LOGIN_PAGE_VERIFY_PIN_CODE,
  PHONE_LOGIN_SUBMIT,
  LOGOUT,
  REGISTER,
  REGISTER_PAGE_GETPINCODE,
  ASSET_CREATE,
  ASSET_UPDATE,
  NEWS_CREATE,
  NEWS_UPDATE,
  NEWS_DELETE,
  ACCOUNT_GO,
  SEND_VERIFICATION_EMAIL,
  MY_DETAIL_SUBMITTED,
  CHANGE_AVATAR_SUBMITTED,
  VERIFYID_SUBMITTED,
  CHANGE_PHONE_SUBMITTED,
  CHANGE_PASSWORD_SUBMITTED,
  CONFIRM_REDIRECT_TO,
  CLEAR_CONFIRM_REDIRECT_TO,
  CLEAR_REDIRECT,
  WITHDRAW_GET_TRANS_FEE,
  GRAPH_LOAD,
  BOOK_LOAD,
  TRANSACTION_STATS_LOAD,
  TOTP_SUBMIT,
  UPDATE_SECURITY,
  REFRESH_TOKEN_VERSION,
  ASYNC_START,
  ASYNC_END,
  PENDING,
  CERTIFICATE_ADD,
  ISSUER_UPDATE,
  ACCOUNT_SUBSCRIBE,
  CERTIFICATE_FILE_UPLOADED,
  CERTIFICATE_BULK_CREATE,
  FILE_UPLOAD,
  DIRECTORY_ADD,
  DIRECTORY_UPDATE,
  DIRECTORY_REMOVE,
  FILE_DELETE,
  GROUP_ADD,
  GROUP_REMOVE,
} from '../constants/actionTypes';

import {
  REACT_APP_BASE_COIN_SYMBOL,
  REACT_APP_SITE_SYMBOL,
} from '../constants/config'

const defaultState = {
  //appName: REACT_APP_SITE_SYMBOL === 'XIF' ? 'XIF Scan' : 'Prime Scan',
  //orgName: REACT_APP_SITE_SYMBOL === 'XIF' ? 'X Infinity' : 'Pellar Technology',
  token: null,
  viewChangeCounter: 0
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case APP_LOAD:
      return {
        ...state,
        token: action.token || null,
        appLoaded: true,
        configs: action.payload[0] ? action.payload[0].configs : null,
        currentUser: action.payload[1] ? action.payload[1].user : null
      };
    case REDIRECT:
      return { ...state, redirectTo: null }
    case CONFIRM_REDIRECT_TO:
      return {
        ...state,
        confirmInfo: action.confirmInfo,
        redirectTo: '/confirm'
      }
    case PENDING: {
      return { ...state, redirectTo: '/pending', token: null, currentUser: null };
    }
    case CLEAR_CONFIRM_REDIRECT_TO:
      return { ...state, confirmInfo: null };
    case CLEAR_REDIRECT:
      return { ...state, confirmInfo: null };

    case LOGIN:
      return {
        ...state,
        token: action.error ? null : action.payload.user ? action.payload.user.token : null,
        currentUser: action.error ? null : action.payload.user ? action.payload.user : null,
        redirectTo: action.error ? null : action.payload.user.token ? '/files' : 'verification',
      }
    case LOGIN_PAGE_VERIFY_PIN_CODE:
    case PHONE_LOGIN_SUBMIT:
      return {
        ...state,
        token: action.error ? null : action.payload.user.token,
        currentUser: action.error ? null : action.payload.user,
        redirectTo: action.error ? null : '/files',
      }
    case LOGOUT:
      return { ...state, redirectTo: '/', token: null, currentUser: null };
    case REGISTER:
      return {
        ...state,
        redirectTo: action.error ? null : '/files',
        token: action.error ? null : action.payload.user.token,
        currentUser: action.error ? null : action.payload.user,
      }
    case ACCOUNT_SUBSCRIBE:
      return {
        ...state,
        redirectTo: action.error ? null : '/certificates?subscribe=success'
      }
    case CERTIFICATE_ADD:
      return {
        ...state,
        redirectTo: action.error ? null : (action.nextStep === 'continue' ? null : '/certificates'),
      }
    // case CERTIFICATE_FILE_UPLOADED:
    //   return {
    //     ...state,
    //     redirectTo: action.error ? null : '/certificates/pending',
    //   }
    case FILE_UPLOAD:
    case DIRECTORY_ADD:
    case DIRECTORY_UPDATE:
    case DIRECTORY_REMOVE:
    case FILE_DELETE:
      let redirectTo
      if (!action.error) {
        if (action.directory) {
          redirectTo = '/files?directory=' + action.directory
        } else {
          redirectTo = '/files'
        }
      }
      return {
        ...state,
        redirectTo: redirectTo,
      }
    case GROUP_ADD:
    case GROUP_REMOVE:
      return {
        ...state,
        redirectTo: action.error ? null : '/groups',
      }
    case CERTIFICATE_BULK_CREATE:
      return {
        ...state,
        redirectTo: action.error ? null : '/certificates',
      };
    case ASSET_CREATE:
    case ASSET_UPDATE:
      return {
        ...state,
        redirectTo: action.error ? null : '/assets',
      }
    case NEWS_CREATE:
    case NEWS_UPDATE:
    case NEWS_DELETE:
      return {
        ...state,
        redirectTo: action.error ? null : '/news',
      }
    case ACCOUNT_GO:
      return { ...state, redirectTo: '/account/' + action.payload }

    case MY_DETAIL_SUBMITTED:
    case CHANGE_AVATAR_SUBMITTED:
    case VERIFYID_SUBMITTED:
    case TOTP_SUBMIT:
      return {
        ...state,
        currentUser: action.error ? state.currentUser : action.payload.user,
      }
    case CHANGE_PHONE_SUBMITTED:
    case CHANGE_PASSWORD_SUBMITTED:
    case REFRESH_TOKEN_VERSION:
      var user = state.currentUser
      var token = state.token
      if (user && !action.error) {
        user = action.payload.user
        token = action.payload.user.token
      }
      return {
        ...state,
        currentUser: user,
        token: token,
      }
    case UPDATE_SECURITY:
      var user = state.currentUser
      if (user && !action.error && action.payload.user) {
        user.two_FA_type = action.payload.user.two_FA_type
        user.two_FA_enabled = action.payload.user.two_FA_enabled
        user.two_FA_enabled_trade = action.payload.user.two_FA_enabled_trade
        user.two_FA_enabled_withdraw = action.payload.user.two_FA_enabled_withdraw
      }
      return {
        ...state,
        currentUser: user
      }
    case GRAPH_LOAD:
      return {
        ...state,
        marketData: action.payload ? action.payload : null,
      }
    case BOOK_LOAD:
      return {
        ...state,
        bookData: action.payload ? action.payload : null,
      }
    case TRANSACTION_STATS_LOAD:
      return {
        ...state,
        stats: action.error ? null : action.payload.stats
      }
    case ASYNC_START:
      if (action.subtype !== LOGOUT && action.subtype !== REGISTER_PAGE_GETPINCODE && action.subtype !== CHANGE_PASSWORD_SUBMITTED
        && action.subtype !== GRAPH_LOAD && action.subtype !== BOOK_LOAD && action.subtype !== TRANSACTION_STATS_LOAD
        && action.subtype !== SEND_VERIFICATION_EMAIL && action.subtype !== WITHDRAW_GET_TRANS_FEE) {
        return {
          ...state,
          inProgress: true
        }
      }
    case ASYNC_END:
      return { ...state, inProgress: false }
    default:
      return state;
  }
};
